import { render, staticRenderFns } from "./SalesPayment.vue?vue&type=template&id=b9232f12"
import script from "./SalesPayment.vue?vue&type=script&lang=js"
export * from "./SalesPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports